import { SPACING } from "../../../constants/Spacing";
import { SIZES } from '../../../constants/Sizes';
import { COLORS } from "../../../constants/Colors";
import { FONTS } from "../../../constants/Fonts";

const MOBILE = '@media (max-width: 768px)';

export const SX_STYLES = {
    logoContainer: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        marginLeft: SPACING.x_large,
        marginRight: SPACING._22px,
        [MOBILE]: { flexDirection: 'column', alignItems: 'flex-start' },
    },
    logoStyle: {
        height: '4.2vh',
        marginRight: SPACING._6px,
        [MOBILE]: { height: '6vw' },
    },
    logoName: {
        ...FONTS.font600,
        fontSize: SIZES._16px,
        color: COLORS.blueD66,
        [MOBILE]: { fontSize: '4vw' },
    },
    footerContainer: {
        marginTop: SPACING._48px,
        [MOBILE]: { marginTop: '6vw' },
    },
    contactContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: SPACING._48px,
        paddingBottom: SPACING._48px,
        paddingLeft: SPACING.x_large,
        paddingRight: SPACING.x_large,
        background: COLORS.blueD4,
        [MOBILE]: { flexDirection: 'column', alignItems: 'flex-start', gap: '4vw', paddingLeft: '4vw', paddingRight: '4vw', paddingTop: '6vw', paddingBottom: '6vw' },
    },
    footerSectionLabel: {
        ...FONTS.font500,
        fontSize: SIZES._30px,
        color: COLORS.white,
        [MOBILE]: { fontSize: '5vw' },
    },
    footerSubLabel: {
        ...FONTS.font300,
        fontSize: SIZES._20px,
        color: COLORS.grayEA, 
        marginTop: SPACING._16px,
        [MOBILE]: { fontSize: '3.5vw' },
    },
    emailContainer: {
        display: 'flex', 
        gap: SPACING._16px,
        [MOBILE]: { width: '100%', flexWrap: 'wrap' },
    },
    textFieldStyle: {
        height: '5.8vh',
        background: COLORS.white, 
        borderRadius: 2, 
        border: 0,
        [MOBILE]: { height: '10vw', width: '100%' },
    },
    emailInput: {
        sx: {
            ...FONTS.font300,
            fontSize: SIZES._16px,
            height: '6vh',
        }
    },
    footerLinksContainer:{
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: SPACING.x_large,
        paddingRight: SPACING.x_large,
        paddingTop: SPACING._64px,
        paddingBottom: '4.5vh',
        gap: SPACING._64px,
        [MOBILE]: { paddingLeft: '4vw', paddingRight: '4vw', paddingTop: '6vw', paddingBottom: '6vw', gap: '5vw' },
    },
    footerLinksWrapper: {
        display: 'flex', 
        gap: '3vw',
        [MOBILE]: { flexDirection: 'column', gap: '5vw' },
    },
    footerCompanyDescription: {
        ...FONTS.font300,
        fontSize: SIZES._16px,
        marginTop: SPACING._20px,
        [MOBILE]: { fontSize: '3.5vw', marginTop: '4vw' },
    },
    linkContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: SPACING._16px,
        marginRight: '10vw', 
    },
    divider: {
        backgroundColor: COLORS.grayEA
    },
    copyRightContainer: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginTop: SPACING._32px,
    },
    copyRight: {
        ...FONTS.font300,
        fontSize: SIZES._16px,
        color: COLORS.gray98
    },
    socialIconContainer: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        gap: '2.4vh'
    },
    twitter: {
        color: COLORS.gray98, 
        fontSize: '3.5vh'
    }
}